import React, { useState, useContext, createContext } from 'react'
import { createTheme } from '@material-ui/core'

const ThemeContext = createContext()
export const useTheme = () => {
    return useContext(ThemeContext)
}

export const ThemeProvider = ({children}) => {
    const darkTheme = createTheme({  //creating theme
        palette: {
          type: 'dark',
          primary: {
            main: '#ff5722',
            mainGradient: 'linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%)',
          },
          secondary: {
            main: '#1de9b6',
            mainGradient: 'linear-gradient(315deg, #00aa7f, #47bf9b, #70d4b7, #95ead3, #baffee)'
          },
          background: {
            defaultPrimary: "linear-gradient(315deg, #000000 -20%, #414141 74%)",
            defaultSecondary: "linear-gradient(45deg, #000000 -60%, #414141 60%)"
          }
        },
        typography: {
          fontFamily: 'Ubuntu',
          fontWeightLight: 400,
          fontWeightRegular: 500,
          fontWeightMedium: 600,
          fontWeightBold: 700,
        }
    });
    const lightTheme = createTheme({  //creating theme
      palette: {
        type: 'light',
        primary: {
          main: '#36096d',
          mainGradient: 'linear-gradient(315deg, #99ccff 0%, #b1f2ff 74%)',
        },
        secondary: {
          main: '#1de9b6',
          mainGradient: 'linear-gradient(315deg, #00aa7f, #47bf9b, #70d4b7, #95ead3, #baffee)'
        },
        background: {
          defaultPrimary: "linear-gradient(315deg, #b8c6db 0%, #f5f7fa 74%)",
          defaultSecondary: "linear-gradient(45deg, #b8c6db 0%, #f5f7fa 74%)"
        }
      },
      typography: {
        fontFamily: 'Ubuntu',
        fontWeightLight: 400,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 700,
      }
    });

    const [isDark, setIsDark] = useState(false)
    const toggleTheme = () => {
        setIsDark(!isDark)
        localStorage.setItem('isDark', !isDark)
    }

    const themeProvider = {
        isDark,
        darkTheme,
        lightTheme,
        toggleTheme,
    }
    
    return (
        <ThemeContext.Provider value={themeProvider}>
            {children}
        </ThemeContext.Provider>
    )
}